import { render, staticRenderFns } from "./Review2.vue?vue&type=template&id=44ed9f08&"
import script from "./Review2.vue?vue&type=script&lang=js&"
export * from "./Review2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports